export const resumeLink="https://drive.google.com/file/d/1-SzPg21shWXWUErvRx49AVQwgob_d-Sd/view?usp=drive_link"